<section #sectionContainer>
    @if(isModal) {
        <h2 mat-dialog-title class="dialog-title">{{ dialogTitle }}</h2>
    }
    @else {
        <h2 class="dialog-title" style="padding-top: 10px">{{ dialogTitle }}</h2>
    }
    
    @if (isModal) {
        <mat-dialog-content *ngIf="!interviewLoaded || !interviewManager.constantMapKeysLoaded">
            <mat-spinner diameter="20"></mat-spinner>
        </mat-dialog-content>
    }

    <mat-dialog-content [id]="sectionContainerHtmlId" *ngIf="interviewLoaded && interviewManager.constantMapKeysLoaded">
        <interview-new-field-alert></interview-new-field-alert>
        <dynamic-form
            [expandAllQuestions]="true"
            [selectedQuestion]="interviewManager.selectedQuestion"
            [interviewMode]="interviewManager.interviewMode"
            [parentIndex]=""
            [sectionLocked]="interviewManager.formattedSection.isLocked"
            [(constantLists)]="interviewManager.constantLists"
            [config]="interviewManager.formattedSection.questions"
            [formattedSection]="interviewManager.formattedSection">
        </dynamic-form>
    </mat-dialog-content>

    <interview-processing-status class="d-block px-4 pb-2"></interview-processing-status>
    @if(isModal) {
    <mat-dialog-actions align="end" >
        <mrs-btn-tertiary class="close-btn" buttonId="close" buttonLabel="Close" (onClick)="handleClose()"></mrs-btn-tertiary>
        <mrs-btn-primary [buttonLabel]="saveButtonLabel" buttonId="saveDecision" [disabled]="interviewService.processingIndicator$ | async" (click)="handleSave()"></mrs-btn-primary>
    </mat-dialog-actions>
}
@else {
    <div style="display: flex; padding-bottom: 50px;">
        <mrs-btn-tertiary class="close-btn" buttonId="close" buttonLabel="Close" (onClick)="handleClose()"></mrs-btn-tertiary>
        <mrs-btn-primary [buttonLabel]="saveButtonLabel" buttonId="saveDecision" [disabled]="interviewService.processingIndicator$ | async" (click)="handleSave()"></mrs-btn-primary>
    </div>
}
</section>